import { render } from "./international.vue?vue&type=template&id=245fd8f2&scoped=true"
import script from "./international.vue?vue&type=script&lang=js"
export * from "./international.vue?vue&type=script&lang=js"

import "./international.vue?vue&type=style&index=0&id=245fd8f2&lang=css"
import "./international.vue?vue&type=style&index=1&id=245fd8f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245fd8f2"]])

export default __exports__